import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types"
import * as SelectionActions from "../../reducers/selection";
import {Card} from "antd"
import {DetailsTitle} from "../../util/Util";
import SelectionDetailTable from "./SelectionTableDetail"
import Chart from "../../components/chart";

class SelectionDetails extends React.Component {

    static propTypes = {
        findSelection: PropTypes.func.isRequired,
        fetchingSingle: PropTypes.bool.isRequired
    };

    state = {
        selectedRows: [], // Check here to configure the default column
    };
    onSelectChange = (selectedRows) => {
        console.log('selectedRowKeys changed: ', selectedRows);
        this.setState({selectedRows});
    };

    componentDidMount() {
        const {match, findSelection} = this.props;
        const urlId = match.params.id;
        findSelection(urlId);
    }

    render() {
        const {fetchingSingle, selectionDetails} = this.props;
        const {selectedRows} = this.state;
        return <div><Card title={<DetailsTitle icon="area-chart">{selectionDetails.selectionName}</DetailsTitle>}
                          loading={fetchingSingle}/>
            <div className="selection-left">

                <SelectionDetailTable dataSource={selectionDetails.selections}
                                      onSelectChange={this.onSelectChange}
                                      loading={fetchingSingle}/>}
            </div>
            <div className="selection-left">
                <Chart datasets={selectedRows}/>
            </div>
        </div>
    }
}


const mapStateToProps = state => {
    console.log("map", state);
    return ({
        selectionDetails: state.selection.selectionDetails,
        fetchingSingle: state.selection.fetchingSingle
    })
};

const mapDispatchToProps = dispatch => ({
    findSelection: bindActionCreators(SelectionActions, dispatch).findSelection,
    search: bindActionCreators(SelectionActions, dispatch).search
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectionDetails)


// WEBPACK FOOTER //
// ./src/js/browse/selection/SelectionDetails.js